import React from "react"
import { Flex, Image, Typography } from "antd"

import icon from "@src/app/assets/chat-icon.svg"
export const HelloStepUi = () => {
  return (
    <Flex gap={16} vertical>
      <Typography.Paragraph>
        Congrats on joining us! Start exploring the tools for receiving,
        exchanging, and sending cryptocurrencies. Take a quick guided tour to
        make the most of your dashboard.
        <div style={{ margin: "12px 0" }}>
          <Image height={60} preview={false} src={icon} width={60}></Image>
        </div>
        Need help? Click the chat icon in the bottom right corner to contact our
        support team or contact us via telegram @cryptix_chat
      </Typography.Paragraph>
    </Flex>
  )
}
